import cn from "./cn";
import en from "./en";
import th from "./th";

const localDictionaries = {
  cn,
  en,
  th,
  zh: cn
};

const dictionary = (dict, word, params, lang = "th") => {
  const normalizedLang = String(lang).toLowerCase().split(/[-_]/)[0];
  const localDictionary = localDictionaries[normalizedLang] || th;
  let text = dict?.[word] || localDictionary?.[word] || th[word];
  if (!text) return word;
  if (params && typeof params === "object") {
    text = text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
      params[key] !== undefined && params[key] !== null
        ? String(params[key])
        : match
    );
  }
  return text;
};
export default dictionary;
